import CCColors from "@/Utils/CCColors";

const styles = {
  overlayContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  overlayCard: {
    backgroundColor: CCColors.White,
    borderRadius: 12,
    padding: 16,
    width: "80%",
    height: "90%",
    display: "flex",
    flexDirection: "column",
    zIndex: 99999,
  },

  closeButton: {
    backgroundColor: 'white',
    borderColor: '#22222240',
    borderWidth: 1,
    height: 30,
    width: 30,
    cursor: 'pointer',
  },
  leftSection: {
    flex: 2,
    paddingRight: 16,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    zIndex: 9999,
    borderColor: 'grey',
  },
  closeIcon: {
    flex:0.5,
    alignItems: 'flex-end'
    // position: 'absolute',
    // top: 16,
    // right: 16,
  },
  rightSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  engineSection: {
    flex: 1.5,
    borderBottom: `1px solid ${CCColors.LightGray}`,
    paddingBottom: 8,
    marginBottom: 8,

  },
  engineHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  notationSection: {
    flex: 4,
    overflow: 'hidden'
  },
  chessboardContainer: {
    flex: 1,
    display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // position: "relative",
    marginLeft: 16,
    aspectRatio: "1", // Maintain square aspect ratio
    width: "calc(80vh - 60px)", // Leave space for title
  },
  footer: {
    marginTop: 16,
    display: "flex",
    justifyContent: "center",
    alignItems: 'center'
  },
  resetButton: {
    backgroundColor: CCColors.LightGray,
  },
  solved: {
    marginLeft: "16px",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#e6ffe6",
    border: "1px solid #70c470",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: 'row',
    width: "calc(80vh - 60px)"
  }
};

export default styles;
